// extracted by mini-css-extract-plugin
export default {"container":"SimpleErrorBlock__container___n4q9e","errorMessages":"SimpleErrorBlock__errorMessages___hQdUX"};